import * as fromAuth from '../actions/auth.action';
import { User } from 'oidc-client';
import { LoadingGroup } from '../models/loading.model';
import { ActionReducer } from '@ngrx/store';

export interface AuthState {
    authentified: boolean;
    user: User;
    userIsPasswordlessApprenant: boolean;
    loadingGroup: LoadingGroup;
    redirectUrl: string;
}

/** Auth reducer */
export function reducer(
    state: AuthState = {
        authentified: false,
        user: null,
        userIsPasswordlessApprenant: false,
        loadingGroup: new LoadingGroup(),
        redirectUrl: null,
    },
    action: fromAuth.AuthAction
) {
    switch (action.type) {

        case fromAuth.AUTH_CO:
        case fromAuth.AUTH_DECO: {
            return {
                ...state,
                loadingGroup: state.loadingGroup.start(),
            };
        }

        case fromAuth.AUTH_CO_SILENT: {
          const user = action.payload;
          if (user) {
            const userIsPasswordlessApprenant: boolean = user?.profile?.attributes?.profile === "apprenant-pless";
            let preferred_username: string;
            let idApprenant: string;
            if(userIsPasswordlessApprenant) {
              preferred_username = user.profile.attributes.preferred_username;
              idApprenant = user.profile.sub;
            } else {
              preferred_username = user.profile.sub;
            }
            return {
                ...state,
                user: {
                  ...user,
                  preferred_username,
                  profile: {
                    ...user.profile,
                    idApprenant,
                  }
                },
                userIsPasswordlessApprenant,
            };
          }
          return {
            ...state,
            user,
            userIsPasswordlessApprenant: false,
        }

      }

        case fromAuth.AUTH_CO_SUCCESS: {
            return {
                ...state,
                authentified: true,
                loadingGroup: state.loadingGroup.success()
            };
        }

        case fromAuth.AUTH_CO_REGISTER_REDIRECT_URL: {
          const redirectUrl = action.payload.redirectUrl;
          return {
              ...state,
              redirectUrl: redirectUrl,
          };
      }

      case fromAuth.AUTH_CO_FAIL:
        case fromAuth.AUTH_DECO_FAIL: {
            const error = action.payload;
            return {
                ...state,
                loadingGroup: state.loadingGroup.fail(error)
            };
        }

        case fromAuth.AUTH_DECO_SUCCESS: {
            return {
                ...state,
                authentified: false,
                user: null,
                userIsPasswordlessApprenant: false,
                loadingGroup: state.loadingGroup.success()
            };
        }

        default:
            return state;
    }

}

/**
 * Clean the store when auth deco success
 * @param myReducer reducer
 */
export function authLogoutMetaReducer(myReducer: ActionReducer<any>): ActionReducer<any> {
    return function (state, action) {
        return myReducer(action.type === fromAuth.AUTH_DECO_SUCCESS ? undefined : state, action);
    };
}

